/* The active design system tokens. Pure code-motion from src/App.jsx
   (Phase 2 group 3).

   Important: `brand` is a mutable singleton. Consumers (200+ inline-style
   sites in App.jsx, plus future extracted modules) read its properties
   at render time. The org picker mutates `brand.*` in place when an org
   is selected — see the `applyOrgBrand` effect in NovoNavigator. ESM
   bindings preserve this — every importer sees the same object. */

export const brand = {
  prussianBlue: "#08314d",
  porcelainBlue: "#e8f1f7",
  prussianBlueLight: "#0b4a72",
  textPrimary: "#08314d",
  accentColor: "#08314d",
  textSecondary: "#3d6380",
  textMuted: "#7a9bb5",
  borderLight: "#d4e3ed",
  bgPage: "#f3f7fa",
  white: "#ffffff",
  font: "'Montserrat', sans-serif",
  dangerRed: "#dc2626",
  successGreen: "#16a34a",
  constructionYellow: "#f5a623",
  constructionYellowLight: "#fef3d9",
  constructionYellowBorder: "#eac06a",
  constructionYellowText: "#8a5a00",
};

/* Colour of the lift shadow under a hovered service tile.
   One colour for every org, deliberately. It is NOT taken from the org
   palette: each org's secondary is near-white (IRCNoCo's is pure white), so a
   shadow tinted with it cannot be seen against the page, and reusing the
   primary just reads as a soft edge under a border of the same colour.
   Turquoise sits well against all four primaries — navy, blue, green, teal. */
export const TILE_SHADOW = "#17b8a6";

/* Hex colour -> rgba string, for tinting shadows with an org's palette.
   Accepts #rgb and #rrggbb; anything unrecognised comes back untouched so a
   bad value degrades to "no tint" rather than an invalid style. */
export function withAlpha(hex, alpha) {
  const h = String(hex || "").trim().replace(/^#/, "");
  const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
  if (!/^[0-9a-f]{6}$/i.test(full)) return hex;
  const n = parseInt(full, 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}

// Build a dynamic brand object from org config
export const buildBrand = (org) => {
  const base = {
    prussianBlue: org ? org.primary : '#08314d',
    porcelainBlue: org ? org.secondary : '#e8f1f7',
    prussianBlueLight: org ? org.primary + '99' : '#0b4a72',
    textPrimary: org ? org.primary : '#08314d',
    textOnPrimary: org ? org.textOnPrimary : '#ffffff',
  };
  return base;
};
